function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Image, Space, Result, Button } from "antd";
import OrderFromCustomer from '../components/forms/OrderFromCustomer';
import DefaultNav from '../components/navbars/DefaultNav';
import { ShieldFillCheck, WalletFill, TelephoneFill, HouseFill, GeoAltFill, Stopwatch, HourglassSplit } from "react-bootstrap-icons";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import { Link, useParams } from 'react-router-dom';
import Common from '../components/includes/Common';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Order = function Order() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    lastCreatedOrder = _useState2[0],
    setLastCreatedOrder = _useState2[1];
  var _useParams = useParams(),
    orderid = _useParams.orderid;
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    transactionStatus = _useState4[0],
    setTransactionStatus = _useState4[1];
  useEffect(function () {
    if (orderid) {
      axios.get(Common.baseApiUrl + 'gettransactionstatus/' + orderid).then(function (response) {
        setTransactionStatus(response.data.status);
      })["catch"](function (e) {
        notification.error({
          message: "Erreur",
          description: "Impossible de verifier la transaction"
        });
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(DefaultNav, {}), /*#__PURE__*/_jsxs("div", {
      style: {
        background: "#FBF9F7"
      },
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx("div", {
              style: {
                padding: "8px",
                background: "#E5EBF2",
                borderRadius: "12px"
              },
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    style: {
                      paddingBottom: "2px"
                    },
                    children: [/*#__PURE__*/_jsx(SportsModeIcon, {
                      height: "28px"
                    }), /*#__PURE__*/_jsx("div", {
                      children: /*#__PURE__*/_jsx("b", {
                        style: {
                          display: "block",
                          fontSize: "14px"
                        },
                        children: "Livr\xE9s en moins de 45 minutes"
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    style: {
                      paddingBottom: "2px"
                    },
                    children: [/*#__PURE__*/_jsx(GeoAltFill, {
                      size: 22
                    }), /*#__PURE__*/_jsx("div", {
                      children: /*#__PURE__*/_jsx("b", {
                        style: {
                          display: "block",
                          fontSize: "14px"
                        },
                        children: "Kip\xE9, Transervale T2"
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    style: {
                      paddingBottom: "2px"
                    },
                    children: [/*#__PURE__*/_jsx(TelephoneFill, {
                      size: 22
                    }), /*#__PURE__*/_jsx("div", {
                      children: /*#__PURE__*/_jsx("b", {
                        style: {
                          display: "block",
                          fontSize: "14px"
                        },
                        children: "Support: (+224) 620 000 000"
                      })
                    })]
                  })
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 6,
            children: !orderid ? /*#__PURE__*/_jsx("div", {
              style: {
                background: "#EBE4DD",
                padding: "12px",
                borderRadius: "0px 12px 0px 12px",
                marginTop: "0px"
              },
              children: /*#__PURE__*/_jsx(OrderFromCustomer, {
                handler: function handler() {}
              })
            }) : /*#__PURE__*/_jsx("div", {
              className: "s-box  white-bg",
              style: {
                borderRadius: "12px 12px 12px 12px"
              },
              children: transactionStatus != null && /*#__PURE__*/_jsxs("div", {
                children: [transactionStatus == 1 && /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(Result, {
                    status: "success",
                    title: "Paiement \xE9ffectu\xE9 avec succ\xE8s !",
                    subTitle: /*#__PURE__*/_jsxs("div", {
                      children: [/*#__PURE__*/_jsx("h6", {
                        children: "Veuillez vous rendre \xE0 la clinique Medvie le jour de votre rendez-vous"
                      }), /*#__PURE__*/_jsx("p", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Adresse : Kip\xE9, Kaporo"
                        })
                      })]
                    }),
                    extra: [/*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      size: "large",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "REPRENDRE RENDEZ-VOUS"
                      })
                    }, "console"), /*#__PURE__*/_jsx(Button, {
                      size: "large",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CONTINUER SUR LE SITE"
                      })
                    }, "buy")]
                  }), /*#__PURE__*/_jsx("br", {})]
                }), transactionStatus == 2 && /*#__PURE__*/_jsx(Result, {
                  status: "error",
                  title: "Echec du paiement!",
                  subTitle: "Veuillez verifier votre compte et puis recommencer ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "large",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "NOUVELLE COMMANDE"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    size: "large",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                }), transactionStatus == 0 && /*#__PURE__*/_jsx(Result, {
                  icon: /*#__PURE__*/_jsx(HourglassSplit, {
                    size: 45,
                    color: "#EC8242"
                  }),
                  title: "Paiement en cours ...",
                  subTitle: "Votre paiement est en cours de traitement ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "large",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                }), transactionStatus == 3 && /*#__PURE__*/_jsx(Result, {
                  icon: /*#__PURE__*/_jsx(Stopwatch, {}),
                  title: "Transaction expir\xE9e",
                  subTitle: "Trop tard... La transaction a expir\xE9, veuillez essayer encore ...",
                  extra: [/*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "large",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "REPRENDRE"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CONTINUER SUR LE SITE"
                    })
                  })]
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "/drawables/order_hb3.jpg",
              style: {
                borderRadius: "12px",
                marginBottom: "12px",
                marginTop: "0px"
              },
              width: "100%"
            })
          })]
        })]
      })]
    })]
  });
};
export default Order;